const semanticClassNames = {
  root: 'box',
} as const;

export default semanticClassNames;
